import BudgetActionButtonGroupMobile from './BudgetActionButtonGroupMobile';

interface IBudgetRejectionSectionMobileProps {
  rejectionObservation: string;
  onRejectionObservationChange: (value: string) => void;
  onReject: () => void;
  onApprove: () => void;
  rejectLabel?: string;
  approveLabel?: string;
}

const BudgetRejectionSectionMobile = (props: IBudgetRejectionSectionMobileProps) => {
  return (
    <div className="flex-1 flex flex-col justify-between gap-4">
      <div className="flex flex-col flex-1">
        <div className="font-bold mb-2 text-size-12 text-gray-500 pt-1">Observação</div>
        <input
          type="text"
          className="form-control w-full font-size-17"
          placeholder="Insira um texto"
          value={props.rejectionObservation}
          onChange={(e) => props.onRejectionObservationChange(e.target.value)}
        />
      </div>
      <div className="flex flex-col mt-4 justify-end">
        <BudgetActionButtonGroupMobile
          buttons={[
            {
              label: props.rejectLabel || 'Recusar',
              onClick: props.onReject,
              bsStyle: 'btn-danger',
            },
            {
              label: props.approveLabel || 'Aceitar',
              onClick: props.onApprove,
              bsStyle: 'btn-primary',
            }
          ]}
        />
      </div>
    </div>
  );
};

export default BudgetRejectionSectionMobile;
